/*eslint-disable*/
export let ctx = ""; //canvas对象
export const isFinish = false; //流程是否完结
export let stepData = []; //初始流程步骤数据
export let nodeData = []; //根据leves层级归类后的步骤数据
export let arrowData = []; //流程图关联线段数据
export let box = {
  //当前绘图容器大小
  width: "",
  height: "",
};
export let arrowPosition = [];
export let yShift = 30; //y轴偏移
export let stepWidth = 90; //步骤宽度
export let stepHeight = 28; //步骤高度
export let spacing = 60; //层级之间间隔
export const passLineColor = "#2581d6";
export const defaultLineColor = "#666";

/**
 * 流程线绘制事件
 * @param {*流程基础数据} flowData
 * @param {*canvas对象} context
 * @param {*当前画布尺寸对象} drawbox
 */
export let drawFlowChart = (config, flowData, context, drawbox) => {
  // console.log(config,"config")
  console.log(flowData,"flowData")
  // console.log(context,"context")
  // console.log(drawbox,"drawbox")

  setDrawConfig(config);
  stepData = flowData.nodes ?
    flowData.nodes.filter((item) => item.type == "normal") : [];
     
  arrowData = flowData.arrows ? flowData.arrows : [];
  nodeData = stepData.length > 0 ? MapByJsonKey("levels", stepData) : [];
  box = Object.assign({}, drawbox);
 
  ctx = context;
  arrowPosition = [];
  getLineDraw(config); //进行流程线绘制
};

/**
 * 根据流程绘制数据及配置计算画布高度
 * @param {*} config
 * @param {*} flowData
 */
export let getCanvasHeight = (config, flowData) => {
  let _stepArray = flowData.nodes ?
    flowData.nodes.filter((item) => item.type == "normal") : [];
  let _nodeArray =
    _stepArray.length > 0 ? MapByJsonKey("levels", _stepArray) : [];
  let num = _nodeArray.length + 2;
  let _H = ((config.spacing + config.stepHeight) * num - config.stepHeight) * 1.3;
  return _H;
};
/**计算画布的宽度 */
export let getCanvasWidth = (config, flowData) => {
  let Window_W = document.body.offsetWidth;
  let _stepArray = flowData.nodes ?
    flowData.nodes.filter((item) => item.type == "normal") : [];
  let _nodeArray =
    _stepArray.length > 0 ? getLength("levels", _stepArray) : [];
  let num = _nodeArray;
  let _W = ((10 + config.stepWidth) * num) * 1.8;
  _W = _W > Window_W ? _W : Window_W;
  return _W;
};
/**
 * 流程绘制基本参数配置
 * @param {*配置对象} configOptions
 * @param {*y轴偏移} yShift
 * @param {*步骤宽度} stepWidth
 * @param {*步骤高度} stepHeight
 * @param {*层级之间间隔} spacing
 * @param {*已经完成的颜色} passLineColor
 * @param {*默认颜色} defaultLineColor
 */
export const setDrawConfig = (configOptions) => {
  yShift = configOptions.yShift;
  configOptions.stepWidth ? (stepWidth = configOptions.stepWidth) : "";
  configOptions.stepHeight ? (stepHeight = configOptions.stepHeight) : "";
  configOptions.spacing ? (spacing = configOptions.spacing) : "";
  configOptions.passLineColor ?
    (passLineColor = configOptions.passLineColor) :
    "";
  configOptions.defaultLineColor ?
    (defaultLineColor = configOptions.defaultLineColor) :
    "";
};

/**
 * 根据流程线数据进行流程线绘制
 */
export const getLineDraw = () => {
  
  for (let item of arrowData) {
    //绘制end以上的流程线
    const start = getPosByCode(item.from, "from");
    const end = getPosByCode(item.to, "to");
    // console.log(end,"end")
    drawLine(
      start.x,
      start.y,
      end.x,
      end.y,
      end.isActive ? passLineColor : defaultLineColor
    ); //绘制
  }
  let toEndData = [];
  for (let step of stepData) {
    let arr = arrowData.filter((item) => item.from == step.nodeCode);
    arr.length > 0 ? "" : toEndData.push(step);
  }

  for (let item of toEndData) {
    const start = getPosByCode(item.nodeCode, "from");
    const end = getPosByCode("end", "to");

    drawLine(
      start.x,
      start.y,
      end.x,
      end.y,
      start.isActive && isFinish ? passLineColor : defaultLineColor
    ); //绘制
  }
};

/**
 * 根据步骤code获取步骤坐标
 * @param {*节点编码} code
 * @param {*节点类型from:线段起点,to：线段终点} type
 */
export const getPosByCode = (code, type) => {
  let obj = {};
  obj.code = code;
  obj.type = type;
  if (code == "start") {
    obj.x = box.width / 2;
    obj.y = yShift + stepHeight;
  } else if (code == "end") {
    obj.x = box.width / 2;
    obj.y = (stepHeight + spacing) * (nodeData.length + 1);
  } else {
    
    let index = stepData.findIndex((item) => item.nodeCode == code);

    let level = parseInt(stepData[index].levels); //当前步骤在第几层
   
    
    let _levelIndex = nodeData.findIndex((item) => item.levels == level);
    let _xIndex = nodeData[_levelIndex].children.findIndex(
      (item) => item.nodeCode == code
    ); //当前步骤在x方向第几个
    // console.log(nodeData[_levelIndex].children,"nodeData")
    // console.log(box.width,"box.width")
    obj.isActive =
      _xIndex >= 0 ? nodeData[_levelIndex].children[_xIndex].isActive : false;
    // obj.x =
    //   nodeData[_levelIndex].children.length == 1 ?
    //   box.width / 2 :
    //   (box.width - nodeData[_levelIndex].children.length * stepWidth) / 2 +
    //   stepWidth * (_xIndex + 0.5);
    // code == 'cc2' || code == 'cc3' ? console.log('当前步骤在x方向-='+_xIndex,stepData.length,level,nodeData,_levelIndex,nodeData[_levelIndex].children) : ''
    //备注: 这里的40数值是css的宽度与stepWidth的数差,具体大小可以调试。
    obj.x = nodeData[_levelIndex].children.length == 1 ?
      box.width / 2 : (box.width - (stepWidth + 40) * nodeData[_levelIndex].children.length) / 2 + ((stepWidth + 40) * (_xIndex + 0.5));
    //  code == 'cc2' || code == 'cc3' ? console.log((box.width - nodeData[_levelIndex].children.length * stepWidth) / 2,"112"):''
    //  code == 'cc2' || code == 'cc3' ?console.log((stepWidth * (_xIndex + 0.5)) / 2,"113"):''
    //  code == 'cc2' || code == 'cc3' ?console.log(obj.x,"obj.x =="):''
    //  code == 'cc2' || code == 'cc3' ?console.log((box.width- (stepWidth + 10)*nodeData[_levelIndex].children.length)/2 + ((stepWidth + 10) * (_xIndex + 0.5)),"实际算的==="):''
    obj.y =
      type == "to" ?
        (stepHeight + spacing) * (_levelIndex + 1) :
        (stepHeight + spacing) * (_levelIndex + 1) + stepHeight;
  }
  arrowPosition.push(obj);
  return obj;
};

/**
 * 单条流程线绘制
 * @param {*线段开始点 x方向坐标} startX
 * @param {*线段开始点 y方向坐标} startY
 * @param {*线段结束点 x方向坐标} endX
 * @param {*线段结束点 y方向坐标} endY
 */
export const drawLine = (fromX, fromY, toX, toY, color) => {
 
  const headlen = 12; //自定义箭头线的长度
  const theta = 15; //自定义箭头线与直线的夹角，个人觉得45°刚刚好
  let arrowX, arrowY; //箭头线终点坐标
  // 计算各角度和对应的箭头终点坐标
  let angle = (Math.atan2(fromY - toY, fromX - toX) * 180) / Math.PI;
  let angle1 = ((angle + theta) * Math.PI) / 180;
  let angle2 = ((angle - theta) * Math.PI) / 180;

  let topX = headlen * Math.cos(angle1);
  let topY = headlen * Math.sin(angle1);
  let botX = headlen * Math.cos(angle2);
  let botY = headlen * Math.sin(angle2);
  ctx.beginPath();
  //画直线
  ctx.lineWidth = 2; //设置线条宽度
  ctx.moveTo(fromX, fromY);
  ctx.lineTo(toX, toY);



  arrowX = toX + topX ;
  arrowY = toY + topY;
  //画上边箭头线
  ctx.moveTo(arrowX, arrowY);
  ctx.lineTo(toX, toY);

  arrowX = toX + botX;
  arrowY = toY + botY;

  //画下边箭头线
  ctx.lineTo(arrowX, arrowY);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = color;
  ctx.strokeStyle = color;
  ctx.stroke();
};

export const drawTriangle = (endX, endY) => {
  ctx.beginPath(); //开始绘制新路径
  ctx.moveTo(endX, endY); //把画笔移动到指定的坐标
  ctx.lineTo(endX - 3, endY - 5); //绘制一条从坐标(50, 50)到坐标(200, 50)的直线
  ctx.lineTo(endX + 3, endY - 5); //绘制一条从坐标(200, 50)到坐标(200, 200)的直线
  ctx.closePath(); //闭合路径，绘制一条从路径起点到路径终点的直线

  ctx.strokeStyle = "green" //设置为绿色
  ctx.stroke(); //填充三角形
  ctx.fillStyle = "red" //设置为红色
  ctx.fill();
};

/**
 * 获取最大层级
 * stepData：审批环节数据
 */
export const getMaxLevel = () => {
  let levelArr = [];
  for (let item of stepData) {
    levelArr.push(item.levels);
  }
  return levelArr.length == 0 ?
    "" :
    levelArr.reduce(function (a, b) {
      return b > a ? b : a;
    });
};

export const getSelectParentCode = (nodeCode, arrowsData) => {
  let result = [];
  let arr = arrowsData.filter((item) => item.to == nodeCode);
  for (let item of arr) {
    result.push(item.from);
  }
  return result;
};

/**
 * 数组json根据key进行分类归纳
 * @param {*需要分类的key名称} keyName
 * @param {*原始数组 arr
 */
export const MapByJsonKey = (keyName, arr) => {
  var map = {},
    dest = [];
  for (var i = 0; i < arr.length; i++) {
    var ai = arr[i];
    if (!map[ai[keyName]]) {
      let obj = {};
      obj[keyName] = ai[keyName];
      obj.children = [ai];
      dest.push(obj);
      map[ai[keyName]] = ai;
    } else {
      for (var j = 0; j < dest.length; j++) {
        var dj = dest[j];
        if (dj[keyName] == ai[keyName]) {
          dj.children.push(ai);
          break;
        }
      }
    }
  }
  return dest;
};
/**
 *  
 *  数组json获取最大length值
 */

export const getLength = (keyName, arr) => {

  let Arr2 = [];
  let dest = '';

  arr.sort(function(a,b){
    var value1 = a.levels;
    var value2 = b.levels;
    return value1 - value2;
}); //注意，一定要排序，不排序，会重复判断，从而错误
  for (var i = 0; i < arr.length;) { //按照属性判断属性合并列数
    var count = 0;
    for (var j = i; j < arr.length; j++) {
      if (arr[i].levels == arr[j].levels) {
        count++;
      }
    }
    Arr2.push(
      count
    )
    i += count;
  }
  dest = Math.max.apply(null, Arr2);

  return dest
}